import BrowserStore from 'store';
import DeviceDetector from 'device-detector-js';

const deviceDetector = new DeviceDetector();
const USER_AGENT = window.navigator.userAgent;
const DEVICE_INFO = deviceDetector.parse(USER_AGENT);
const BROWSER_VERSION = parseFloat(Number(DEVICE_INFO.client.version));
const OS_VERSION = parseFloat(Number(DEVICE_INFO.os.version));

export default {
  computed: {
    isIpadOS() {
      return !!navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
    },

    defineRecordingFlow() {
      // Returns RESULT
      // 'notallowed' = not allowed in this browser - download another browser
      // 'default' = Classic default recording scheme

      if (DEVICE_INFO.os.name === 'Mac') {
        // If IPadOS
        // temporary badbrowser dummy until fix video stuck on ipads
        // if (this.isIpadOS) {
        //   if (DEVICE_INFO.client.name.indexOf('Safari') >= 0) {
        //     return 'notallowed';
        //   }

        //   return 'default_ios';
        // }
        //     if (BROWSER_VERSION >= 14) {
        //       return 'default';
        //     }
        //     return 'notallowed';
        //   }
        // } else {
        //   // If MacOS
        //   if (DEVICE_INFO.client.name.indexOf('Safari') >= 0) {
        //     if (BROWSER_VERSION >= 14) {
        //       return 'default';
        //     }
        //     return 'notallowed';
        //   }
        // }
        if (DEVICE_INFO.client.name.indexOf('Safari') >= 0) {
          if (BROWSER_VERSION >= 14) {
            return 'default';
          }

          return 'notallowed';
        }

        return 'default';
      } else if (
        DEVICE_INFO.os.name === 'iOS' ||
        USER_AGENT.indexOf('iPhone') >= 0 ||
        USER_AGENT.indexOf('iPad') >= 0
      ) {
        // If Iphone
        if (OS_VERSION >= 14.5) {
          return 'default_ios';
        }
        return 'notallowed';
      }

      return 'default';
    },

    // TODO: NEED TO BE REMOVED
    checkIosVersion() {
      var agent = window.navigator.userAgent,
        start = agent.indexOf('OS ');
      if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1 || this.isIpadOS) && start > -1) {
        return window.Number(agent.substr(start + 3, 4).replace('_', '.'));
      }
      return 0;
    },

    getUserMediaCrossPlatform() {
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.mediaDevices.getUserMedia;
      return navigator.getUserMedia;
    },

    // TODO: NEED TO BE REMOVED
    // много где используется
    isIos() {
      const ua = navigator.userAgent;
      const isIosWay = !!BrowserStore.get('is_ios');
      const isIos = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      const isIpadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

      return isIosWay || isIos || isIpadOs;
    },

    // TODO: NEED TO BE REMOVED
    // много где используется
    isSafari() {
      const ua = navigator.userAgent.toLowerCase();

      if (!this.isIos) {
        return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
      } else {
        return navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
      }
    },

    // TODO: NEED TO BE REMOVED
    // Используется только в vcv2/frontend/src/routes_new/outer/interview/landing/video/default.vue
    isIosSafari() {
      if (!this.isIos) {
        return false;
      }

      const isIosWay = !!BrowserStore.get('is_ios');

      if (isIosWay) {
        return true;
      }
      const ua = navigator.userAgent.toLowerCase();
      const isIpadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

      if (isIpadOs) {
        return isIpadOs && /WebKit/i.test(ua) && !/(CriOS|FxiOS|OPiOS|mercury)/i.test(ua);
      }

      return /iP(ad|od|hone)/i.test(ua) && /WebKit/i.test(ua) && !/(CriOS|FxiOS|OPiOS|mercury)/i.test(ua);
    }
  }
};
